import { Globe, Check, Languages } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

const OPTS = [
  { code: "ar", label: "العربية", short: "ع" },
  { code: "en", label: "English", short: "EN" },
  { code: "ur", label: "اردو", short: "اردو" },
];
const REVIEW = { ar: "مراجعة الترجمات", en: "Review translations", ur: "ترجموں کا جائزہ" };

export const LanguageSwitcher = ({ className = "", tone = "light", onReview }) => {
  const { lang, setLang } = useLang();
  const current = OPTS.find((o) => o.code === lang) || OPTS[0];
  const trigger = tone === "dark"
    ? "border-white/20 bg-white/10 text-white hover:bg-white/20"
    : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid="language-switcher" data-no-translate
          className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 h-9 text-xs font-bold transition ${trigger} ${className}`}>
          <Globe className="h-3.5 w-3.5 opacity-80" />
          <span>{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem] font-body" data-no-translate>
        {OPTS.map((o) => (
          <DropdownMenuItem key={o.code} data-testid={`lang-${o.code}`} onClick={() => setLang(o.code)}
            className="flex items-center justify-between gap-3 cursor-pointer">
            <span className="flex items-center gap-2">
              <span className="text-xs font-bold w-8 text-slate-400">{o.short}</span>
              {o.label}
            </span>
            {lang === o.code && <Check className="h-4 w-4 text-blue-600" />}
          </DropdownMenuItem>
        ))}
        {onReview && <>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="lang-review" onClick={onReview} className="flex cursor-pointer items-center gap-2 text-blue-700">
            <Languages className="h-4 w-4" /> {REVIEW[lang] || REVIEW.ar}
          </DropdownMenuItem>
        </>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
